import { Get } from "../../../../Request";

export const GetData = async () => {
  return await Get({
    url: "/setting/general_show",
  }).then(data => {
    return data;
  });
};
export const ShowData = (data, key) => {
  let result = null;
  data.filter(data => {
    if (data.key == key) {
      result = data.value;
    }
  });
  return result;
};
export const checkEmpty = data => {
  switch (data) {
    case "":
    case undefined:
    case []:
    case null:
      return false;

    default:
      return true;
  }
};
